import { useEffect, useState } from 'react';

function useTransCodeHook() {
  const [transcodeDone, setTranscodeDone] = useState<any>(null);
  const handleTranscode = () => {
    localStorage.setItem('transcodingDone', 'true');
    setTranscodeDone(true);
  };

  useEffect(() => {
    const transcodeLocalStorage = localStorage.getItem('transcodingDone');
    if (transcodeLocalStorage) {
      setTranscodeDone(transcodeLocalStorage === 'true');
    } else {
      setTranscodeDone(false);
    }
  }, [transcodeDone]);

  return [transcodeDone, handleTranscode, setTranscodeDone];
}

export default useTransCodeHook;
